export default __webpack_public_path__ + "static/media/ngo-gif3.ec5ef572.gif";